module.exports = __webpack_public_path__ + "static/media/heart_filled.82c3594a.png";